import { Component } from '@angular/core';
import {AConcreteResource} from "../../../AConcreteResource";
import {FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {HttpErrorsService} from "../../../../services/utils/http-errors.service";
import {CustomNotificationService} from "../../../../services/utils/custom-notification.service";
import {SafeUpdateService} from "../../../../services/utils/safe-update.service";
import {finalize} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";
import {EmployeeModel} from "../../../../models/resources/employee.model";
import {MdbButtonComponent} from "../../../utils/mdb-button/mdb-button.component";
import {SpinnerComponent} from "../../../utils/spinner/spinner.component";
import {EmployeeService} from "../../../../services/resources/employee.service";
import {EmployeeFormComponent} from "../../../forms/employee-form/employee-form.component";

@Component({
  selector: 'app-employee',
  imports: [
    EmployeeFormComponent,
    MdbButtonComponent,
    SpinnerComponent,
  ],
  templateUrl: './employee.component.html',
  styleUrl: './employee.component.scss',
})
export class EmployeeComponent extends AConcreteResource<EmployeeModel> {
  loading: boolean = false;
  formGroup: FormGroup | undefined;

  constructor(
    router: Router,
    private employeeService: EmployeeService,
    private httpErrorService: HttpErrorsService,
    private notificationService: CustomNotificationService,
    private safeUpdateService: SafeUpdateService
) {
    super(router, employeeService);
  }

  submit(serverResource: any = null, overrideValues: { [key: string]: any } = {}) {
    this.formGroup!.markAllAsTouched();

    if (this.formGroup!.invalid) return;

    this.loading = true;

    let resource = this.formGroup?.value;

    resource.updatedAt = this.model()!.updatedAt;

    if (serverResource)
      resource = this.safeUpdateService.handleResource(resource, serverResource, overrideValues);

    this.employeeService
      .update(this.model()!.id, resource)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: () => {
          this.notificationService.success('CHANGES_SUCCESSFULLY_SAVED');
        },
        error: (e: HttpErrorResponse) => {
          this.httpErrorService.handleError(e, (newServerResource, newOverrideValues) => {
            this.submit(newServerResource, newOverrideValues);
          });
        },
      });
  }
}
